<template>
  <div>
    <table class="table is-striped is-hoverable is-fullwidth is-size-7">
      <tr>
        <th>Balance Id</th>
        <th>User</th>
        <th>Requested</th>
        <th>Total In</th>
        <th>Total Out</th>
        <th>Balance</th>
        <th>Approved</th>
        <th>Pending</th>
      </tr>
      <tr v-for="{ balance, user } of requests">
        <td>{{ balance.id }}</td>
        <td>{{ user.id }} ({{ user.username }})</td>
        <td>
          {{ balance.requestedOut | currency(balance.currency) }}
          <div>
            <a href="javascript:void(0);" class="link has-text-link" @click="openDialog(balance, 'approve');">Approve</a>
            |
            <a href="javascript:void(0);" class="link has-text-link" @click="openDialog(balance, 'decline');">Decline</a>
          </div>
        </td>
        <td>{{ balance.totalIn | currency(balance.currency) }}</td>
        <td>{{ balance.totalOut | currency(balance.currency) }}</td>
        <td>{{ balance.real | currency(balance.currency) }}</td>
        <td>{{ balance.approvedOut | currency(balance.currency) }}</td>
        <td>{{ balance.pendingOut | currency(balance.currency) }}</td>
      </tr>
    </table>
    <div v-if="!requests.length">
      No Requests
    </div>
    <div v-show="selectedBalance" class="modal" ref="modal">
      <template v-if="selectedBalance">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ selectedBalance._ui.dialog.title }}</p>
            <button class="delete" aria-label="close" @click="closeDialog();"></button>
          </header>
          <section class="modal-card-body">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Available</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control has-text-white">
                    <span class="oc-form-text">{{selectedBalance.requestedOut | currency(selectedBalance.currency)}}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Amount</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input v-model="selectedBalance._ui.amount.value"
                           :error-messages="errors.collect('Amount')"
                           :class="[{ 'is-danger': errors.has('Amount') }, 'input']"
                           :disabled="selectedBalance.requestedOut <= 0"
                           data-vv-name="Amount"
                           type="text"
                           v-validate="`required|between:${selectedBalance._ui.amount.min},${selectedBalance._ui.amount.max}`" />
                  </p>
                  <span v-if="errors.has('Amount')" class="help is-danger">{{ errors.first('Amount') }}</span>
                </div>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-link" @click="process();">Process</button>
            <button class="button" @click="closeDialog();">Cancel</button>
          </footer>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import balanceService from "../../../services/balance.service";
  import currencyService from "../../../services/currency.service";

  export default {
    name: "withdrawal-requests",
    $_veeValidate: { validator: "new" },
    data: () => ({
      requests: [],
      selectedBalance: null
    }),
    mounted() {
      this.loadRequests();
    },
    methods: {
      async loadRequests() {
        this.requests.length = 0
        this.requests.push(...(await balanceService.getWithdrawalRequestsAsync()));
      },
      openDialog(balance, mode) {
        balance._ui = {
          mode: mode,
          amount: {
            value: balance.requestedOut / 100,
            min: currencyService.getMinimal(balance.currency),
            max: currencyService.formatInvariant(balance.requestedOut, balance.currency)
          },
          dialog: {
            title: mode === "approve" ? "Approve" : "Decline"
          }
        };

        this.selectedBalance = balance;
        this.$refs.modal.classList.add("is-active");
      },
      closeDialog() {
        this.selectedBalance = null;
        this.$refs.modal.classList.remove("is-active");
      },
      async process() {
        this.errors.clear();
        const isValid = await this.$validator.validateAll().then(isValid => isValid);
        if (isValid) {
          const action = this.selectedBalance._ui.mode === "approve" ? balanceService.approveRequestedWithdrawalAsync : balanceService.declineRequestedWithdrawalAsync;
          const result = await action({ balanceId: this.selectedBalance.id, amount: this.selectedBalance._ui.amount.value });
          if (result.isSuccess) {
            this.closeDialog();
            this.loadRequests();
          }
          else {
            if (result.error === "InternalError") {
              this.errors.add({ field: result.error, msg: result.errorMessage })
            }
            else {
              result.errorData.forEach(error => this.errors.add({ field: error.key, msg: error.message }));
            }
          }
        }
      }
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/client/payment-system/withdrawal-requests.vue